import { render, staticRenderFns } from "./trans_short.vue?vue&type=template&id=83bb7870"
import script from "./trans_short.vue?vue&type=script&lang=js"
export * from "./trans_short.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports